import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';
import { convertToIconFormat } from '../../icon-search/icon-list';

@Component({
  selector: 'rk-dropdown-icon',
  standalone: false,
  templateUrl: './dropdown-icon.component.html',
  styleUrl: './dropdown-icon.component.scss',
})
export class DropdownIconComponent {
  @Input() faIcon?: string;
  @Input() legacyIcon?: string;

  getFaIcon(iconName: string) {
    return convertToIconFormat(iconName);
  }

  getLegacyIconLink(iconName: string) {
    return iconName
      ? `https://www.${environment.urls.RADIOKING_DOMAIN}/images/mobile/icons/${iconName}.png`
      : null;
  }
}
